import type { Lang } from '../types';
import { bus } from '../events';
import { qa } from '../dom';
import { es } from './es';
import { pt } from './pt';

const DICT: Record<Lang, Record<string, string>> = { es, pt };

let lang: Lang = 'es';

export const getLang = (): Lang => lang;

/** Tradução por chave. Devolve o fallback (ou a própria chave) quando não existe. */
export const t = (key: string, fallback?: string): string => DICT[lang][key] ?? fallback ?? key;

/** Aplica `data-i18n` só dentro de um subtree, sem avisar ninguém (para componentes recém-desenhados). */
export function translateWithin(root: ParentNode): void {
  qa('[data-i18n]', root).forEach(el => {
    const v = t(el.dataset.i18n as string, el.textContent ?? '');
    if (v.includes('<')) el.innerHTML = v; else el.textContent = v;
  });
}

/** Aplica `data-i18n` em toda a página e avisa as features para redesenharem. */
export function applyLang(): void {
  translateWithin(document);
  document.documentElement.lang = lang;
  bus.emit('lang', lang);
}

export function setLang(next: Lang): void {
  lang = next;
  applyLang();
}

/** Texto curto que depende do idioma sem passar pelo dicionário. */
export const pick = (esText: string, ptText: string): string => (lang === 'pt' ? ptText : esText);
